import { apiRequest } from "../../shared/api/client";
import type {
  LabelAccessUpdate,
  LabelUserCreate,
  PersonnelAccessList,
  PersonnelAccessSource,
  PinResult,
  PersonnelAccessHistory,
} from "../../../shared/personnel-access/contracts";
import { personnelAccessEntrySchema, personnelAccessHistorySchema, personnelAccessListSchema, pinResultSchema } from "../../../shared/personnel-access/contracts";

const base = "/api/personnel-access";

export const personnelAccessApi = {
  list: async () => personnelAccessListSchema.parse(await apiRequest<PersonnelAccessList>(base, { cache: "no-store" })),
  history: async (source: PersonnelAccessSource, personId: string) => ({ items: personnelAccessHistorySchema.array().parse((await apiRequest<{ items: PersonnelAccessHistory[] }>(`${base}/${encodeURIComponent(source)}/${encodeURIComponent(personId)}/history`, { cache: "no-store" })).items) }),
  revealPin: async (source: PersonnelAccessSource, personId: string) =>
    pinResultSchema.parse(await apiRequest<PinResult>(`${base}/${encodeURIComponent(source)}/${encodeURIComponent(personId)}/pin/reveal`, { method: "POST", body: JSON.stringify({}) })),
  generatePin: async (source: PersonnelAccessSource, personId: string, expectedUpdatedAt: string | null) =>
    pinResultSchema.parse(await apiRequest<PinResult>(`${base}/${encodeURIComponent(source)}/${encodeURIComponent(personId)}/pin/generate`, { method: "POST", body: JSON.stringify({ expectedUpdatedAt }) })),
  replaceLabelAccess: (personId: string, input: LabelAccessUpdate) =>
    apiRequest<void>(`${base}/label/${encodeURIComponent(personId)}`, { method: "PUT", body: JSON.stringify(input) }),
  removeLabelAccess: (personId: string) =>
    apiRequest<void>(`${base}/label/${encodeURIComponent(personId)}`, { method: "DELETE" }),
  createLabelUser: async (input: LabelUserCreate) =>
    personnelAccessEntrySchema.parse(await apiRequest(`${base}/label/users`, { method: "POST", body: JSON.stringify(input) })),
};
